import { Box, Text } from '@chakra-ui/react';
import React from 'react';

export const Footer: React.FC = () => (
  <Box w="full" mt="auto">
    <Text>American Made Intelligence</Text>
  </Box>
);
